import React, { useRef, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage.js';
import { ProjectsPage } from './pages/ProjectsPage';
import { CalendarPage } from './pages/CalendarPage';
import { ContactPage } from './pages/ContactPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { PaymentPage } from './pages/PaymentPage';
import { PaymentStatusPage } from './pages/PaymentsStatusPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage.js';

import { useNavigate } from 'react-router-dom';
import { navigateRef } from 'athena-core/ref/navigateRef';
import { modalRef, ModalRefType } from 'athena-core/ref/modalRef';
import Modal from './components/Modal.js';

import './styles/global.css';
import './styles/fonts.css';

function App() {
  const modalController = useRef<{
    openModal: (params: ModalRefType) => void;
    closeModal: () => void;
  }>(null);

  const siteInit = useRef(true);

  const navigate = useNavigate();

  useEffect(() => {
    console.log('did run App useEffect to set refs');
    modalRef.current = {
      openModal: (params) => {
        modalController.current?.openModal(params);
      },
      closeModal: () => {
        modalController.current?.closeModal();
      },
    };

    if (siteInit.current === true) {
      console.log('First visit - showing welcome message');
      modalRef.current.openModal({
        title: 'Thanks for visiting!',
        message: 'sign up to book a consultation or view my projects.',
      });
      siteInit.current = false;
    }

    navigateRef.goTo = (path: string) => {
      navigate(path);
    };
  }, [navigate]);

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/verify" element={<VerifyEmailPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment-status" element={<PaymentStatusPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />}></Route>
      </Routes>
      <Modal ref={modalController}></Modal>
    </>
  );
}

export default App;
